export const getUrlFromUnknownIPFSorHTTP = (url) => {
  const protocol = url.split('://')[0];
  const hashCode = url.split('://')[1];

  if (protocol === 'ipfs' || url.split(':')[0] === 'IPFS')
    return 'https://ipfs.io/ipfs/' + hashCode;
  return url;
};
